import React, { Component } from "react"
import axios from "axios"
import settings from "settings"
import { Formik, Field, Form } from "formik"
import cancelFields from "models/cancel"
import DateField from "components/DateField"
import fieldStatus from "helpers/fieldStatus"
import * as Yup from "yup"
import submitData from "helpers/submitData"
import ReactSelect from "components/ReactSelect"
import _ from "lodash"
import { connect } from "react-redux"
import { loadingStatus, getPayload } from "actions"
import { bindActionCreators } from "redux"

class BustoutModal extends Component {
	constructor(props) {
		super(props)
		this.state = {
			fields: cancelFields,
			data: {
				address: "",
			},
		}
	}

	componentDidMount() {
		let data = this.props.data
		if (this.props.data.super) {
			data = _.last(this.props.data.sales)
			data.sale_id = data.id
		}
		let userToken = localStorage.getItem("user")
		axios
			.post(settings.ep + "/getSale", data, {
				headers: { Authorization: `Bearer ${userToken}` },
			})
			.then((resp) => {
				this.setState({
					data: resp.data,
				})
			})
	}

	validation = () => {
		let shape = {
			//salesperson: Yup.number().required("Required"),
			bustout_reason: Yup.string().min(5, "Must be longer than 5 characters").required("Required"),
			bustout_date: Yup.number().required("Required"),
		}

		if (settings?.builderPortal?.cancelReasons) {
			shape.cancel_other_reason = Yup.string().when("bustout_reason", {
				is: "Other", // when bustout_reason equals "Other"
				then: (schema) => schema.required("Please specify the reason"),
				otherwise: (schema) => schema.notRequired(),
			})
		}

		return Yup.object().shape(shape)
	}

	submitClasses = (f) => {
		var classNames = require("classnames")
		var submitClasses = classNames("form__submit", {
			"form__submit--ready": f,
		})

		return submitClasses
	}

	spOptions = () => {
		let sps = []
		_.forEach(this.props.payload.public.salespeople, (v) => {
			if (
				v.builders.includes(this.props.data.lot.builder) &&
				v.properties.includes(this.props.data.lot.property)
			) {
				sps.push({
					label: `${v.first} ${v.last}`,
					value: v.id,
				})
			}
		})

		return sps
	}

	outputReason = (f) => {
		// Some developers (airia) wanted cancel reasons in a dropdown where if they select other hty have to then fill out another field witha text reason.  Combine these on submit.
		if (settings?.builderPortal?.cancelReasons) {
			let ret = []
			// First the dropdown
			ret.push(
				<li className={fieldStatus("bustout_reason", f)} key={`bustout_reason`}>
					<label htmlFor="bustout_reason">
						Cancel Reason<sup>*</sup>
					</label>
					{f.errors.bustout_reason && f.touched.bustout_reason && (
						<div className="form__message">{f.errors.bustout_reason}</div>
					)}
					<ReactSelect
						name={`bustout_reason`}
						options={_.map(settings.builderPortal.cancelReasons, (v, k) => {
							return { value: v, label: v }
						})}
						className="form__input"
						value={f.values.bustout_reason}
						onChange={f.setFieldValue}
						onBlur={f.setFieldTouched}
						touched={f.touched.length > 0 && f.touched.bustout_reason}
						error={f.errors.length > 0 && f.errors.bustout_reason}
					/>
				</li>
			)
			// Then the text field
			if (f.values.bustout_reason === "Other") {
				ret.push(
					<li className={fieldStatus("cancel_other_reason", f)} key={`cancel other reason`}>
						<label htmlFor="cancel_other_reason">
							Other Reason<sup>*</sup>
						</label>
						{f.errors.cancel_other_reason && f.touched.cancel_other_reason && (
							<div className="form__message">{f.errors.cancel_other_reason}</div>
						)}
						<Field name="cancel_other_reason" type="text" className="form__input" />
					</li>
				)
			}
			return ret
		}

		return (
			<li className={fieldStatus("bustout_reason", f)}>
				<label htmlFor="bustout_reason">
					Cancel Reason<sup>*</sup>
				</label>
				{f.errors.bustout_reason && f.touched.bustout_reason && (
					<div className="form__message">{f.errors.bustout_reason}</div>
				)}
				<Field name="bustout_reason" type="text" className="form__input" />
			</li>
		)
	}

	render() {
		let co
		if (this.state.data.co_first) {
			co = ` & ${this.state.data.co_first} ${this.state.data.co_last}`
		}
		return (
			<div className="modal">
				<h3>
					Cancel Contract: {this.props.data.address} | {this.state.data.buyer_first}{" "}
					{this.state.data.buyer_last}
					{co}
				</h3>
				<Formik
					initialValues={this.state.fields}
					validateOnMount={true}
					validationSchema={this.validation}
					onSubmit={(values) => {
						// On the super side with adding this
						if (this.props.data.super) {
							values.sale_id = this.props.data.lot.sale_id
						} else {
							// On the salesperson side
							values.sale_id = this.props.data.sale_id
						}
						if (values.cancel_other_reason) {
							values.bustout_reason = `${values.bustout_reason} - ${values.cancel_other_reason}`
						}
						delete values.cancel_other_reason
						submitData("inputBustout", values)
							.then((data) => {
								this.props.notify(data, this.props.name)
							})
							.catch((e) => {
								this.props.notify(e, this.props.name)
							})
					}}
					render={(f) => (
						<div>
							{console.log(f)}
							<Form>
								<ul className="modalForm__list">
									{/* <li className={fieldStatus("salesperson", f)}>
										<label htmlFor="salesperson">
											Salesperson<sup>*</sup>
										</label>
										{f.errors.salesperson && f.touched.salesperson && (
											<div className="form__message">{f.errors.salesperson}</div>
										)}
										<ReactSelect
											name={`salesperson`}
											options={this.spOptions()}
											value={f.values.salesperson}
											onBlur={f.setFieldTouched}
											onChange={f.setFieldValue}
										/>
									</li> */}
									{this.outputReason(f)}
									<li className={fieldStatus("bustout_date", f)}>
										<label htmlFor="bustout_date">
											Cancel Date <sup>*</sup>
										</label>
										{f.errors.bustout_date && f.touched.bustout_date && (
											<div className="form__message">{f.errors.bustout_date}</div>
										)}
										<DateField
											name="bustout_date"
											className="form__textarea"
											value={f.values.bustout_date}
											onChange={f.setFieldValue}
											onBlur={f.setFieldTouched}
											touched={f.touched.bustout_date}
											error={f.errors.bustout_date}
											blockFuture={true}
										/>
									</li>
								</ul>
								<input type="submit" value="Submit" className={this.submitClasses(f.isValid)} />
							</Form>
						</div>
					)}
				/>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		trafficSources: state.trafficSources,
		payload: state.payload,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			getPayload,
			loadingStatus,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(BustoutModal)
